// import { motion } from 'framer-motion';
// import { Link } from 'react-router-dom';
// import { FiArrowRight } from "react-icons/fi";
// import { FaStar, FaCrown, FaBriefcase, FaBuilding, FaCity, FaGlobe, FaRocket, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
// import KeyMember from './KeyMember';
// import HelpDeskSection from './HelpDeskSection';

// export default function MemberShip() {
//   const categories = [
//     {
//       title: "Patron Membership",
//       description: "A socially responsible corporate organisation of considerable size, importance and standing with operations across any sector, in India and/or abroad.",
//       icon: <FaCrown className="w-6 h-6 text-white" />,
//       premium: true
//     },
//     {
//       title: "Associate Membership",
//       description: "A reputable organisation (sole proprietary concern, company, body corporate, society, limited liability partnership) engaged in trade, commerce, agriculture, services or profession.",
//       icon: <FaBriefcase className="w-6 h-6 text-[#DA2128]" />,
//       premium: false
//     },
//     {
//       title: "Professional Membership",
//       description: "A profit-earning firm, sole proprietary concern, body corporate engaged in the profession of medical practitioners, doctors, lawyers, legal counsels, Chartered Accountants, Company Secretaries, etc.",
//       icon: <FaStar className="w-6 h-6 text-[#DA2128]" />,
//       premium: false
//     },
//     {
//       title: "Institutional Membership",
//       description: "Organisations incorporated for the object of and engaged in the promotion of literature, science, fine arts, diffusion of useful knowledge or for any other charitable purpose or public utility or welfare.",
//       icon: <FaBuilding className="w-6 h-6 text-[#DA2128]" />,
//       premium: false
//     },
//     {
//       title: "International Membership",
//       description: "Corporates incorporated or having its principal place of business outside India and carrying out business by way of liaison office/branch office/project office in India, Institutions, Chamber of Commerce having a presence outside India.",
//       icon: <FaGlobe className="w-6 h-6 text-[#DA2128]" />,
//       premium: false
//     },
//     {
//       title: "Startup Membership",
//       description: "Startups can apply for membership as per eligibility in terms of Technology Readiness Level (TRL) or Fund Raised.",
//       icon: <FaRocket className="w-6 h-6 text-[#DA2128]" />,
//       premium: false
//     }
//   ];

//   const helpDesk = [
//     { name: "Gautam Sengupta", phone: "+91 9999311483", email: "gautam.sengupta@assocham.com" },
//      { name: "Sunita Dobhal", phone: "+91 9818325433", email: "sunita.dobhal@assocham.com" },
//      { name: "Hrithik Verma", phone: "+91 7838981998", email: "hrithik.verma@assocham.com" },
//     { name: "Nusrat Wajahat", phone: "+91 9868906133", email: "nusrat.wajahat@assocham.com" },
    
//   ];


//   const fadeInUp = {
//   hidden: { opacity: 0, y: 30 },
//   visible: { 
//     opacity: 1, 
//     y: 0, 
//     transition: { duration: 0.6, ease: "easeOut" } 
//   }
// };

// function Breadcrumb() {
//   return (
//     <nav
//       aria-label="Breadcrumb"
//       className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
//     >
//       <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
//         <li>
//           <a
//             href="#top"
//             className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
//           >
//             <svg
//               viewBox="0 0 24 24"
//               className="h-4 w-4"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2.2}
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <path d="M3 10.5 12 3l9 7.5" />
//               <path d="M5 10v10h14V10" />
//               <path d="M9 20v-6h6v6" />
//             </svg>
//             Home
//           </a>
//         </li>
      
//         <li className="text-black/30">&rsaquo;</li>
//         <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm"> Membership</li>
//       </ol>
//     </nav>
//   );
// }

//   return (
//     <div className="min-h-screen bg-brand-light font-sans text-gray-800">
//       {/* Header with Action Buttons */}
//       <header className="relative bg-gradient-to-br from-white via-[#FFF5F3] to-[#FFE8E4] py-12 px-6 lg:px-20 overflow-hidden">
//         <Breadcrumb />
//         {/* Subtle Animated Background Elements */}
//         <div className="absolute inset-0">
//           <div className="absolute top-[-30%] right-[-20%] w-[50%] h-[70%] bg-[radial-gradient(ellipse_at_center,_rgba(218,33,40,0.06)_0%,_transparent_70%)]"></div>
//           <div className="absolute bottom-[-30%] left-[-20%] w-[50%] h-[70%] bg-[radial-gradient(ellipse_at_center,_rgba(232,93,40,0.05)_0%,_transparent_70%)]"></div>
//         </div>

//         {/* Abstract Decorative Shapes */}
//         <motion.div
//           className="absolute top-10 right-16 w-32 h-32 rounded-full border border-[#DA2128]/10"
//           animate={{
//             scale: [1, 1.1, 1],
//             rotate: [0, 180, 360],
//           }}
//           transition={{
//             duration: 20,
//             repeat: Infinity,
//             ease: "linear"
//           }}
//         />
//         <motion.div
//           className="absolute bottom-10 left-16 w-24 h-24 rounded-full border border-[#E85D28]/10"
//           animate={{
//             scale: [1, 1.2, 1],
//             rotate: [360, 180, 0],
//           }}
//           transition={{
//             duration: 15,
//             repeat: Infinity,
//             ease: "linear"
//           }}
//         />
        
//         {/* Small geometric accents */}
//         <div className="absolute top-1/3 right-8 w-12 h-12 bg-[#DA2128]/5 rounded-lg transform rotate-45"></div>
//         <div className="absolute bottom-1/4 left-8 w-10 h-10 bg-[#E85D28]/5 rounded-lg transform rotate-12"></div>
//         <div className="absolute top-1/4 left-1/3 w-6 h-6 bg-[#DA2128]/5 rounded-full"></div>

//         {/* Dots Pattern */}
//         <div className="absolute inset-0 opacity-20">
//           <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
//             <defs>
//               <pattern id="dots" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
//                 <circle cx="2" cy="2" r="1" fill="#DA2128" opacity="0.3"/>
//               </pattern>
//             </defs>
//             <rect width="100%" height="100%" fill="url(#dots)" />
//           </svg>
//         </div>

//         {/* Content */}
//         <motion.div 
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6, ease: "easeOut" }}
//           className="relative z-10 max-w-7xl mx-auto text-center"
//         >
//           {/* MEMBERSHIP Badge */}
//           {/* <motion.div
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.4, delay: 0.1 }}
//             className="inline-block mb-4"
//           >
//             <div className="relative">
//               <div className="relative bg-white/90 backdrop-blur-sm px-6 py-2 rounded-full shadow-md border border-[#DA2128]/10">
//                 <span className="text-xs font-bold tracking-[0.15em] text-[#DA2128] uppercase">
//                   <span className="inline-block mr-2 text-[#DA2128]">●</span>
//                   Membership
//                 </span>
//               </div>
//             </div>
//           </motion.div> */}

//           {/* Main Heading - Compact */}
//           {/* <motion.h1
//             initial={{ opacity: 0, y: 10 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.2 }}
//             className="text-4xl md:text-6xl font-extrabold leading-[1.1]"
//           >
//             <motion.span
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ duration: 0.6, delay: 0.3 }}
//               className="bg-gradient-to-r from-[#DA2128] via-[#E85D28] to-[#DA2128] bg-clip-text text-transparent bg-300% animate-gradient"
//             >
//               ASSOCHAM
//             </motion.span>
//             <br />
//             <span className="text-gray-800 text-2xl md:text-3xl block mt-1">
//               The Knowledge Architect
//             </span>
//             <span className="text-gray-600 text-xl md:text-2xl block font-medium">
//               Of India
//             </span>
//           </motion.h1> */}

//           {/* Tagline */}
//           <motion.p
//             initial={{ opacity: 0, y: 10 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.4 }}
//             className="text-gray-500 max-w-2xl mx-auto text-sm md:text-base font-light tracking-wide mt-3"
//           >
//             Connect with industry leaders, policymakers, innovators, and global business communities through ASSOCHAM Membership — the gateway to India's economic future.
//           </motion.p>

//           {/* Action Buttons */}
//           <motion.div
//             initial={{ opacity: 0, y: 10 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.5 }}
//             className="mt-8 flex flex-col sm:flex-row gap-4 justify-center items-center"
//           >
//             <Link to="/membership-types">
//               <button className="group relative bg-gradient-to-r from-[#DA2128] to-[#A5161C] text-white font-semibold py-3.5 px-10 rounded-full shadow-lg shadow-[#DA2128]/30 hover:shadow-xl hover:shadow-[#DA2128]/40 transform hover:-translate-y-1 transition-all duration-300 flex items-center gap-2 cursor-pointer overflow-hidden">
//                 <span className="relative z-10 flex items-center gap-2">
//                   ASSOCHAM Membership Plans
//                   <FiArrowRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" />
//                 </span>
//                 <span className="absolute inset-0 bg-gradient-to-r from-[#A5161C] to-[#DA2128] opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-full"></span>
//               </button>
//             </Link>
//             <Link to="#membership-category">
//               <button className="group bg-white/90 backdrop-blur-sm text-[#DA2128] font-semibold py-3.5 px-10 rounded-full shadow-md hover:shadow-lg border-2 border-[#DA2128]/30 hover:border-[#DA2128] transform hover:-translate-y-1 transition-all duration-300 flex items-center gap-2 cursor-pointer">
//                 Explore Membership Types
//                 <FiArrowRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" />
//               </button>
//             </Link>
//           </motion.div>

//           {/* Decorative Dots */}
//           <motion.div
//             initial={{ opacity: 0, scaleX: 0 }}
//             animate={{ opacity: 1, scaleX: 1 }}
//             transition={{ duration: 0.6, delay: 0.6 }}
//             className="mt-6 flex justify-center gap-1.5"
//           >
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]/30"></div>
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]/50"></div>
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]/70"></div>
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]"></div>
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]/70"></div>
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]/50"></div>
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]/30"></div>
//           </motion.div>
//         </motion.div>

//         {/* Corner Accents */}
//         <div className="absolute bottom-0 left-0 w-24 h-24 border-l border-b border-[#DA2128]/5 rounded-bl-2xl"></div>
//         <div className="absolute top-0 right-0 w-24 h-24 border-r border-t border-[#DA2128]/5 rounded-tr-2xl"></div>
        
//         {/* Bottom Accent Line */}
//         <div className="absolute bottom-0 left-1/4 right-1/4 h-0.5 bg-gradient-to-r from-transparent via-[#DA2128]/30 to-transparent"></div>
//       </header>

      
//       {/* Overview Section */}
// <section className="py-20 px-6 lg:px-20 bg-brand-light overflow-hidden">
//   <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-16 items-center">
//     {/* Image Composition - Left Side */}
//     <motion.div
//       initial={{ opacity: 0, x: -50 }}
//       whileInView={{ opacity: 1, x: 0 }}
//       viewport={{ once: true }}
//       transition={{ duration: 0.7 }}
//       className="lg:w-1/2 relative"
//     >
//       {/* Decorative Background Element */}
//       <div className="absolute -top-8 -left-8 w-72 h-72 bg-gradient-to-br from-[#DA2128]/10 to-[#E85D28]/5 rounded-full blur-3xl"></div>
      
//       {/* Main Image Container */}
//       <div className="relative h-[500px] w-full">
//         {/* Primary Image - Larger, Background */}
//         <motion.div
//           initial={{ opacity: 0, scale: 0.9 }}
//           whileInView={{ opacity: 1, scale: 1 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.6, delay: 0.2 }}
//           className="absolute top-0 left-0 w-[75%] h-[70%] rounded-3xl overflow-hidden shadow-2xl shadow-gray-400/30 border-4 border-white z-10"
//         >
//           <img
//             src="/images/boardRoomImg.png"
//             alt="ASSOCHAM Boardroom Meeting"
//             className="w-full h-full object-fill"
//           />
//           {/* Subtle Overlay */}
//           <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
//         </motion.div>

//         {/* Secondary Image - Smaller, Overlapping */}
//         <motion.div
//           initial={{ opacity: 0, y: 50, scale: 0.9 }}
//           whileInView={{ opacity: 1, y: 0, scale: 1 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.6, delay: 0.4 }}
//           className="absolute bottom-0 right-0 w-[65%] h-[55%] rounded-3xl overflow-hidden shadow-2xl shadow-[#DA2128]/20 border-4 border-white z-20"
//         >
//           <img
//             src="/images/MemberShip_overview.jpeg"
//             alt="ASSOCHAM Conference Event"
//             className="w-full h-full object-cover"
//           />
//           {/* Accent Border */}
//           <div className="absolute inset-0 rounded-3xl ring-2 ring-inset ring-[#DA2128]/10"></div>
//         </motion.div>

//         {/* Decorative Accent Elements */}
//         <motion.div
//           initial={{ opacity: 0, scale: 0 }}
//           whileInView={{ opacity: 1, scale: 1 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.5, delay: 0.6 }}
//           className="absolute top-[60%] left-[5%] z-30"
//         >
//           <div className="w-20 h-20 bg-gradient-to-br from-[#DA2128] to-[#E85D28] rounded-2xl shadow-xl shadow-[#DA2128]/30 flex items-center justify-center transform -rotate-6">
//             <FaCity className="w-10 h-10 text-white" />
//           </div>
//         </motion.div>

//         {/* Floating Stats Badge */}
//         <motion.div
//           initial={{ opacity: 0, x: 20 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.5, delay: 0.7 }}
//           className="absolute top-8 right-[15%] z-30 bg-white rounded-2xl shadow-xl px-5 py-4 border border-gray-100"
//         >
//           <p className="text-3xl font-bold text-[#DA2128]">250+</p>
//           <p className="text-xs text-gray-500 font-medium">Associations in India and Overseas</p>
//         </motion.div>

//         {/* Dot Pattern Decoration */}
//         <div className="absolute -bottom-4 -left-4 w-24 h-24 opacity-30">
//           <svg viewBox="0 0 100 100" className="w-full h-full">
//             {[...Array(25)].map((_, i) => (
//               <circle
//                 key={i}
//                 cx={(i % 5) * 20 + 10}
//                 cy={Math.floor(i / 5) * 20 + 10}
//                 r="3"
//                 fill="#DA2128"
//               />
//             ))}
//           </svg>
//         </div>
//       </div>
//     </motion.div>

//     {/* Content - Right Side */}
//     <motion.div
//       initial={{ opacity: 0, x: 50 }}
//       whileInView={{ opacity: 1, x: 0 }}
//       viewport={{ once: true }}
//       transition={{ duration: 0.7, delay: 0.2 }}
//       className="lg:w-1/2"
//     >
//       {/* Section Label */}
//       <div className="inline-flex items-center gap-2 bg-[#DA2128]/10 px-4 py-2 rounded-full mb-6">
//         <span className="w-2 h-2 bg-[#DA2128] rounded-full"></span>
//         <span className="text-sm font-semibold text-[#DA2128] uppercase tracking-wider">Overview</span>
//       </div>

//       <div className="space-y-5 mb-10">
//         <p className="text-gray-600 leading-relaxed text-lg">
//           Aligned with the vision of creating a <span className="font-semibold text-gray-800">New India</span>, ASSOCHAM works closely with the Government, industry, and civil society. The Chamber is an agile and forward-looking institution, leading various initiatives to enhance the global competitiveness of the Indian industry.
//         </p>
//         <p className="text-gray-600 leading-relaxed">
//           With more than <span className="font-semibold text-[#DA2128]">100 National and regional councils</span>, ASSOCHAM is an impactful representative of the Indian industry. Our councils and taskforce focus on different sectors and growth segments, working with Central and State Government stakeholders to align critical needs and interests of the industry.
//         </p>
//       </div>

    

//       <Link to="/overview">
//         <button className="group bg-gradient-to-r from-[#DA2128] to-[#E85D28] text-white font-semibold py-4 px-10 rounded-full shadow-lg shadow-[#DA2128]/30 hover:shadow-xl hover:shadow-[#DA2128]/40 transform hover:-translate-y-1 transition-all duration-300 flex items-center gap-3 cursor-pointer">
//           Read More
//           <FiArrowRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" />
//         </button>
//       </Link>
//     </motion.div>
//   </div>
// </section>


//       {/* Key Members */}
//       <KeyMember />

//       {/* Membership Categories */}
//       <section id='membership-category' className="py-20 px-6 lg:px-20 bg-[#FDF2F1]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//              <motion.h2 
//                           variants={fadeInUp}
//                           className="font-serif text-4xl text-[#DA2128] font-medium leading-tight tracking-tight sm:text-3xl lg:text-4xl"
                          
//                         >
//                           Membership {" "}
//                           <motion.span 
//                             className="italic text-[#1F2937]"
//                             initial={{ opacity: 0, x: -20 }}
//                             whileInView={{ opacity: 1, x: 0 }}
//                             viewport={{ once: true }}
//                             transition={{ duration: 0.6, delay: 0.3 }}
//                           >
//                              Categories
//                           </motion.span>
//                         </motion.h2>
//             <p className="text-gray-600 max-w-2xl mx-auto text-lg">
//               Join a network of industry leaders. Choose the membership tier that aligns with your organization's goals and operations.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {categories.map((cat, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 30 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.5, delay: index * 0.1 }}
//                 className={`relative rounded-3xl p-8 flex flex-col h-full ${
//                   cat.premium
//                     ? "pt-16 bg-gradient-to-br from-[#DA2128] to-[#A5161C] text-white shadow-2xl shadow-[#DA2128]/30 transform hover:-translate-y-2 transition-all duration-300"
//                     : "bg-white shadow-xl shadow-gray-200/50 hover:shadow-2xl hover:shadow-gray-300/50 transform hover:-translate-y-2 transition-all duration-300 border border-gray-100"
//                 }`}
//               >
//                 {cat.premium && (
//                   <div className="absolute top-6 left-6 flex items-center gap-1.5 bg-amber-400 text-gray-900 text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide">
//                     <FaStar className="w-3.5 h-3.5 fill-current" /> Premium Tier
//                   </div>
//                 )}

//                 <div className="mb-6">
//                   <div className={`w-14 h-14 rounded-2xl flex items-center justify-center ${
//                     cat.premium ? "bg-white/20 backdrop-blur-sm" : "bg-[#DA2128]/10"
//                   }`}>
//                     {cat.icon}
//                   </div>
//                 </div>

//                 <h4 className={`text-xl font-bold mb-3 ${cat.premium ? "text-white" : "text-gray-900"}`}>
//                   {cat.title}
//                 </h4>

//                 <p className={`mb-8 flex-grow text-sm leading-relaxed ${cat.premium ? "text-white/90" : "text-gray-600"}`}>
//                   {cat.description}
//                 </p>

//                 <button
//                   className={`font-semibold flex items-center gap-2 group w-max cursor-pointer transition-colors ${
//                     cat.premium ? "text-amber-300 hover:text-white" : "text-[#DA2128] hover:text-[#A5161C]"
//                   }`}
//                 >
//                   Apply Now
//                   <FiArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" />
//                 </button>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>
//             < HelpDeskSection />
//     </div>
//   );
// }







// new new code 









import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiArrowRight } from "react-icons/fi";
import { FaStar, FaCrown, FaBriefcase, FaBuilding, FaCity, FaGlobe, FaRocket, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import KeyMember from './KeyMember';
import HelpDeskSection from './HelpDeskSection';

export default function MemberShip() {
  const categories = [
    {
      title: "Patron Membership",
      description: "A socially responsible corporate organisation of considerable size, importance and standing with operations across any sector, in India and/or abroad.",
      icon: <FaCrown className="w-6 h-6 text-white" />,
      premium: true
    },
    {
      title: "Associate Membership",
      description: "A reputable organisation (sole proprietary concern, company, body corporate, society, limited liability partnership) engaged in trade, commerce, agriculture, services or profession.",
      icon: <FaBriefcase className="w-6 h-6 text-[#DA2128]" />,
      premium: false
    },
    {
      title: "Professional Membership",
      description: "A profit-earning firm, sole proprietary concern, body corporate engaged in the profession of medical practitioners, doctors, lawyers, legal counsels, Chartered Accountants, Company Secretaries, etc.",
      icon: <FaStar className="w-6 h-6 text-[#DA2128]" />,
      premium: false
    },
    {
      title: "Institutional Membership",
      description: "Organisations incorporated for the object of and engaged in the promotion of literature, science, fine arts, diffusion of useful knowledge or for any other charitable purpose or public utility or welfare.",
      icon: <FaBuilding className="w-6 h-6 text-[#DA2128]" />,
      premium: false
    },
    {
      title: "International Membership",
      description: "Corporates incorporated or having its principal place of business outside India and carrying out business by way of liaison office/branch office/project office in India, Institutions, Chamber of Commerce having a presence outside India.",
      icon: <FaGlobe className="w-6 h-6 text-[#DA2128]" />,
      premium: false
    },
    {
      title: "Startup Membership",
      description: "Startups can apply for membership as per eligibility in terms of Technology Readiness Level (TRL) or Fund Raised.",
      icon: <FaRocket className="w-6 h-6 text-[#DA2128]" />,
      premium: false
    }
  ];

  const helpDesk = [
    { name: "Gautam Sengupta", phone: "+91 9999311483", email: "gautam.sengupta@assocham.com" },
     { name: "Sunita Dobhal", phone: "+91 9818325433", email: "sunita.dobhal@assocham.com" },
     { name: "Hrithik Verma", phone: "+91 7838981998", email: "hrithik.verma@assocham.com" },
    { name: "Nusrat Wajahat", phone: "+91 9868906133", email: "nusrat.wajahat@assocham.com" },
    
  ];

  // Smooth scroll handler for "Explore Membership Types" button
  const handleScrollToCategories = (e) => {
    e.preventDefault();
    const section = document.getElementById('membership-category');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0, 
    transition: { duration: 0.6, ease: "easeOut" } 
  }
};

function Breadcrumb() {
  return (
    <nav
      aria-label="Breadcrumb"
      className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
    >
      <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
        <li>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
          >
            <svg
              viewBox="0 0 24 24"
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 10.5 12 3l9 7.5" />
              <path d="M5 10v10h14V10" />
              <path d="M9 20v-6h6v6" />
            </svg>
            Home
          </a>
        </li>
      
        <li className="text-black/30">&rsaquo;</li>
        <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm"> Membership</li>
      </ol>
    </nav>
  );
}

  return (
    <div className="min-h-screen bg-brand-light font-sans text-gray-800">
      {/* Header with Action Buttons */}
     <header className="relative overflow-hidden bg-[#1a1a2e] text-white py-12 px-6 lg:px-20 border-b border-gray-100/10">
  {/* Background Image with Overlay */}
  <div 
    className="absolute inset-0 bg-cover bg-center bg-no-repeat"
    style={{ backgroundImage: "url('/Membership.jpg')" }}
  />
  <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/75 to-[#1a1a2e]/80" />

  {/* Top Left Breadcrumb Container */}
  <div className="absolute left-4 top-4 z-20 sm:left-8 sm:top-6">
    <Breadcrumb />
  </div>

  {/* Dots Pattern Overlay */}
  <div className="absolute inset-0 opacity-15 pointer-events-none">
    <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="dots" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
          <circle cx="2" cy="2" r="1" fill="#FFFFFF" opacity="0.4"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#dots)" />
    </svg>
  </div>

  {/* Content Container */}
  <motion.div 
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: "easeOut" }}
    className="relative z-10 max-w-7xl mx-auto text-center pt-8"
  >
    {/* Tagline */}
    <motion.p
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="text-white/90 max-w-2xl mx-auto text-sm md:text-base font-light tracking-wide mt-3 drop-shadow-sm"
    >
      Connect with industry leaders, policymakers, innovators, and global business communities through ASSOCHAM Membership — the gateway to India's economic future.
    </motion.p>

    {/* Action Buttons */}
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
      className="mt-8 flex flex-col sm:flex-row gap-4 justify-center items-center"
    >
      <Link to="/membership-plans">
        <button className="group relative bg-gradient-to-r from-[#DA2128] to-[#A5161C] text-white font-semibold py-3.5 px-10 rounded-full shadow-lg shadow-[#DA2128]/30 hover:shadow-xl hover:shadow-[#DA2128]/40 transform hover:-translate-y-1 transition-all duration-300 flex items-center gap-2 cursor-pointer overflow-hidden">
          <span className="relative z-10 flex items-center gap-2">
            ASSOCHAM Membership Plans
            <FiArrowRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" />
          </span>
          <span className="absolute inset-0 bg-gradient-to-r from-[#A5161C] to-[#DA2128] opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-full"></span>
        </button>
      </Link>

      <button
        onClick={handleScrollToCategories}
        className="group bg-white/95 text-[#DA2128] font-semibold py-3.5 px-10 rounded-full shadow-md hover:shadow-lg border-2 border-[#DA2128]/40 hover:border-[#DA2128] transform hover:-translate-y-1 transition-all duration-300 flex items-center gap-2 cursor-pointer"
      >
        Explore Membership Types
        <FiArrowRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" />
      </button>
    </motion.div>

    {/* Decorative Dots */}
    <motion.div
      initial={{ opacity: 0, scaleX: 0 }}
      animate={{ opacity: 1, scaleX: 1 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      className="mt-6 flex justify-center gap-1.5"
    >
      <div className="w-1.5 h-1.5 rounded-full bg-white/30"></div>
      <div className="w-1.5 h-1.5 rounded-full bg-white/50"></div>
      <div className="w-1.5 h-1.5 rounded-full bg-white/70"></div>
      <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]"></div>
      <div className="w-1.5 h-1.5 rounded-full bg-white/70"></div>
      <div className="w-1.5 h-1.5 rounded-full bg-white/50"></div>
      <div className="w-1.5 h-1.5 rounded-full bg-white/30"></div>
    </motion.div>
  </motion.div>

  {/* Bottom Accent Line */}
  <div className="absolute bottom-0 left-1/4 right-1/4 h-0.5 bg-gradient-to-r from-transparent via-[#DA2128]/40 to-transparent"></div>
</header>

      
      {/* Overview Section */}
<section className="py-20 px-6 lg:px-20 bg-brand-light overflow-hidden">
  <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-16 items-center">
    {/* Image Composition - Left Side */}
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
      className="lg:w-1/2 relative"
    >
      {/* Decorative Background Element */}
      <div className="absolute -top-8 -left-8 w-72 h-72 bg-gradient-to-br from-[#DA2128]/10 to-[#E85D28]/5 rounded-full blur-3xl"></div>
      
      {/* Main Image Container */}
      <div className="relative h-[500px] w-full">
        {/* Primary Image - Larger, Background */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="absolute top-0 left-0 w-[75%] h-[70%] rounded-3xl overflow-hidden shadow-2xl shadow-gray-400/30 border-4 border-white z-10"
        >
          <img
            src="/images/boardRoomImg.png"
            alt="ASSOCHAM Boardroom Meeting"
            className="w-full h-full object-fill"
          />
          {/* Subtle Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        </motion.div>

        {/* Secondary Image - Smaller, Overlapping */}
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="absolute bottom-0 right-0 w-[65%] h-[55%] rounded-3xl overflow-hidden shadow-2xl shadow-[#DA2128]/20 border-4 border-white z-20"
        >
          <img
            src="/images/MemberShip_overview.jpeg"
            alt="ASSOCHAM Conference Event"
            className="w-full h-full object-cover"
          />
          {/* Accent Border */}
          <div className="absolute inset-0 rounded-3xl ring-2 ring-inset ring-[#DA2128]/10"></div>
        </motion.div>

        {/* Decorative Accent Elements */}
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="absolute top-[60%] left-[5%] z-30"
        >
          <div className="w-20 h-20 bg-gradient-to-br from-[#DA2128] to-[#E85D28] rounded-2xl shadow-xl shadow-[#DA2128]/30 flex items-center justify-center transform -rotate-6">
            <FaCity className="w-10 h-10 text-white" />
          </div>
        </motion.div>

        {/* Floating Stats Badge */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.7 }}
          className="absolute top-8 right-[15%] z-30 bg-white rounded-2xl shadow-xl px-5 py-4 border border-gray-100"
        >
          <p className="text-3xl font-bold text-[#DA2128]">250+</p>
          <p className="text-xs text-gray-500 font-medium">Associations in India and Overseas</p>
        </motion.div>

        {/* Dot Pattern Decoration */}
        <div className="absolute -bottom-4 -left-4 w-24 h-24 opacity-30">
          <svg viewBox="0 0 100 100" className="w-full h-full">
            {[...Array(25)].map((_, i) => (
              <circle
                key={i}
                cx={(i % 5) * 20 + 10}
                cy={Math.floor(i / 5) * 20 + 10}
                r="3"
                fill="#DA2128"
              />
            ))}
          </svg>
        </div>
      </div>
    </motion.div>

    {/* Content - Right Side */}
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7, delay: 0.2 }}
      className="lg:w-1/2"
    >
      {/* Section Label */}
      <div className="inline-flex items-center gap-2 bg-[#DA2128]/10 px-4 py-2 rounded-full mb-6">
        <span className="w-2 h-2 bg-[#DA2128] rounded-full"></span>
        <span className="text-sm font-semibold text-[#DA2128] uppercase tracking-wider">Overview</span>
      </div>

      <div className="space-y-5 mb-10">
        <p className="text-gray-600 leading-relaxed text-lg">
          Aligned with the vision of creating a <span className="font-semibold text-gray-800">New India</span>, ASSOCHAM works closely with the Government, industry, and civil society. The Chamber is an agile and forward-looking institution, leading various initiatives to enhance the global competitiveness of the Indian industry.
        </p>
        <p className="text-gray-600 leading-relaxed">
          With more than <span className="font-semibold text-[#DA2128]">100 National and regional councils</span>, ASSOCHAM is an impactful representative of the Indian industry. Our councils and taskforce focus on different sectors and growth segments, working with Central and State Government stakeholders to align critical needs and interests of the industry.
        </p>
      </div>

    

      <Link to="/overview">
        <button className="group bg-gradient-to-r from-[#DA2128] to-[#E85D28] text-white font-semibold py-4 px-10 rounded-full shadow-lg shadow-[#DA2128]/30 hover:shadow-xl hover:shadow-[#DA2128]/40 transform hover:-translate-y-1 transition-all duration-300 flex items-center gap-3 cursor-pointer">
          Read More
          <FiArrowRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" />
        </button>
      </Link>
    </motion.div>
  </div>
</section>


      {/* Key Members */}
      <KeyMember />

      {/* Membership Categories */}
      <section id='membership-category' className="py-20 px-6 lg:px-20 bg-[#FDF2F1] scroll-mt-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
             <motion.h2 
                          variants={fadeInUp}
                          className="font-serif text-4xl text-[#DA2128] font-medium leading-tight tracking-tight sm:text-3xl lg:text-4xl"
                          
                        >
                          Membership {" "}
                          <motion.span 
                            className="italic text-[#1F2937]"
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                          >
                             Categories
                          </motion.span>
                        </motion.h2>
            <p className="text-gray-600 max-w-2xl mx-auto text-lg">
              Join a network of industry leaders. Choose the membership tier that aligns with your organization's goals and operations.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categories.map((cat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className={`relative rounded-3xl p-8 flex flex-col h-full ${
                  cat.premium
                    ? "pt-16 bg-gradient-to-br from-[#DA2128] to-[#A5161C] text-white shadow-2xl shadow-[#DA2128]/30 transform hover:-translate-y-2 transition-all duration-300"
                    : "bg-white shadow-xl shadow-gray-200/50 hover:shadow-2xl hover:shadow-gray-300/50 transform hover:-translate-y-2 transition-all duration-300 border border-gray-100"
                }`}
              >
                {cat.premium && (
                  <div className="absolute top-6 left-6 flex items-center gap-1.5 bg-amber-400 text-gray-900 text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide">
                    <FaStar className="w-3.5 h-3.5 fill-current" /> Premium Tier
                  </div>
                )}

                <div className="mb-6">
                  <div className={`w-14 h-14 rounded-2xl flex items-center justify-center ${
                    cat.premium ? "bg-white/20 backdrop-blur-sm" : "bg-[#DA2128]/10"
                  }`}>
                    {cat.icon}
                  </div>
                </div>

                <h4 className={`text-xl font-bold mb-3 ${cat.premium ? "text-white" : "text-gray-900"}`}>
                  {cat.title}
                </h4>

                <p className={`mb-8 flex-grow text-sm leading-relaxed ${cat.premium ? "text-white/90" : "text-gray-600"}`}>
                  {cat.description}
                </p>

                <button
                  className={`font-semibold flex items-center gap-2 group w-max cursor-pointer transition-colors ${
                    cat.premium ? "text-amber-300 hover:text-white" : "text-[#DA2128] hover:text-[#A5161C]"
                  }`}
                >
                  Apply Now
                  <FiArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" />
                </button>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
            < HelpDeskSection />
    </div>
  );
}